module.exports = __webpack_public_path__ + "e55bceb57f041273aeabe1924e29776b.svg";